import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './components/auth/login/login.component';
import { RegisterComponent } from './components/auth/register/register.component';
import { RegisterMessageComponent } from './components/auth/register-message/register-message.component';
import { RegisterVerifyComponent } from './components/auth/register-verify/register-verify.component';
import { RegisterApproveComponent } from './components/auth/register-approve/register-approve.component';
import { ResetPwComponent } from './components/auth/reset-pw/reset-pw.component';
import { RetrievePwComponent } from './components/auth/retrieve-pw/retrieve-pw.component';

import { PortalComponent } from './components/portal/portal.component';
import { PortalHomeComponent } from './components/portal/portal-home/portal-home.component';
import { AgencyProfileComponent } from './components/portal/agency-profile/agency-profile.component';
import { SubscriptionManageComponent } from './components/portal/subscription-manage/subscription-manage.component';
import { UserManageComponent } from './components/portal/user-manage/user-manage.component';
import { RoleManagementComponent } from './components/portal/role-management/role-management.component';
import { A3iSettingComponent } from './components/portal/a3i-setting/a3i-setting.component';
import { A3iNagComponent } from './components/portal/a3i-setting/a3i-nag/a3i-nag.component';
import { HpmsSettingComponent } from './components/portal/hpms-setting/hpms-setting.component';
import { LbeSettingComponent } from './components/portal/lbe-setting/lbe-setting.component';
import { LbeUploadComponent } from './components/portal/lbe-setting/lbe-upload/lbe-upload.component';
import { LbeUploadArnoldComponent } from './components/portal/lbe-setting/lbe-upload/lbe-upload-arnold/lbe-upload-arnold.component';
import { LbeUploadEventComponent } from './components/portal/lbe-setting/lbe-upload/lbe-upload-event/lbe-upload-event.component';
import { LbeMapComponent } from './components/portal/lbe-setting/lbe-map/lbe-map.component';
import { LbeLrsComponent } from './components/portal/lbe-setting/lbe-lrs/lbe-lrs.component';
import { LbeSymbologyComponent } from './components/portal/lbe-setting/lbe-symbology/lbe-symbology.component';
import { LbePhotologComponent } from './components/portal/lbe-setting/lbe-photolog/lbe-photolog.component';

import { AuthGuardService as AuthGuard } from './common-services/auth-guard.service';
import { AuthTypeGuardService as AuthTypeGuard } from './common-services/auth-type-guard.service';
import { GuardSubscriptionService as SubGuard } from './common-services/guard-subscription.service';
import { GuardSuperUserService as SuperUserGuard } from './common-services/guard-super-user.service';
import { ResolverAppinfoService } from './common-services/resolver-appinfo.service';
import { ResolverAppsService } from './common-services/resolver-apps.service';
import { ResolverSubscriptionsService } from './common-services/resolver-subscriptions.service';
import { ResolverSymbologysService } from './common-services/resolver-symbologys.service';
import { ResolverUserSubsService } from './common-services/resolver-user-subs.service';
import { ResolverLbeLrsService } from './common-services/resolver-lbe-lrs.service';
import { ResolverLbeProjectsService } from './common-services/resolver-lbe-projects.service';
import { ResolverCustomerAppInfoService } from './common-services/resolver-customer-app-info.service';
import { SuperUserComponent } from './components/portal/super-user/super-user.component';
import { ResolverFeatureToggleService } from './common-services/resolver-feature-toggle.service';
import { FeatureToggleSettingComponent } from './components/portal/super-user/feature-toggle-setting/feature-toggle-setting.component';
import { OrganizationComponent } from './components/portal/super-user/organization/organization.component';
import { LbmConfigComponent } from './components/portal/super-user/lbm-config/lbm-config.component';
import { GisticSiteAdminComponent } from './components/portal/super-user/gistic-site-admin/gistic-site-admin.component';
import { ResolverGisticUsersService } from './common-services/resolver-gistic-users.service';
import { LbeLayerColumnsComponent } from './components/portal/lbe-setting/lbe-layer-columns/lbe-layer-columns.component';
import { AuthDirectComponent } from './components/auth-direct/auth-direct.component';
import { SettingsNinjaComponent } from './components/portal/settings-ninja/settings-ninja.component';
import { NinjaLayersComponent } from './components/portal/settings-ninja/ninja-layers/ninja-layers.component';
import { NinjaMetaComponent } from './components/portal/settings-ninja/ninja-meta/ninja-meta.component';
import { AppSettings } from './app.settings';
import { ResolverNinjaInfoService } from './common-services/resolver-ninja-info.service';
import { A3iApikeyComponent } from './components/portal/a3i-setting/a3i-apikey/a3i-apikey.component';
import { GisticDashboardComponent } from './components/portal/gistic-dashboard/gistic-dashboard.component';


// import { AppinfoService } from './common-services/appinfo.service';
// import { AuthenticationService } from './components/auth/auth.service';
// import { AdminService } from './common-services/admin.service';
// import { UserService } from './common-services/user.service';
// import { SubscriptionManagementService } from './common-services/subscription-management.service';

// stateName is required in data property for each Route, which has to be unique
const appRoutes: Routes = [
	// Portal
	/* {
		path: 'portal',
		component: PortalComponent,
		data: { stateName: 'portal'},
		canActivate: [AuthGuard],
		resolve: {
			infoResolve: ResolverAppinfoService,
			subscriptions: ResolverSubscriptionsService,
			featureToggle: ResolverFeatureToggleService
		},
		children: [
			// Home
			{
				path: '',
				component: PortalHomeComponent,
				data: { stateName: 'portalhome', userSubsType: 'currentUser'},
				resolve: { userSubs: ResolverUserSubsService }
			},
			{
				path: 'manage-dashboard',
				component: GisticDashboardComponent
			},
			//
			{
				path: 'agency-profile',
				component: AgencyProfileComponent,
				data: { stateName: 'agencyprofile'}
			},
			// Subscription
			{
				path: 'subscription-manage',
				component: SubscriptionManageComponent,
				data: { stateName: 'subscriptionmanage'},
				resolve: { subscriptions: ResolverSubscriptionsService, apps: ResolverAppsService }
			},
			// User Management
			{
				path: 'user-manage',
				component: UserManageComponent,
				// userSubsType: defines how to call the userSubscriptions function
				// If 'all', get all userSubs regardless of user. If 'currentUser', get userSubs of a specific user
				data: { stateName: 'usermanage'},
				resolve: { subscriptions: ResolverSubscriptionsService, userSubs: ResolverUserSubsService }
			},
			// Role Management
			{
				path: 'role-manage',
				component: RoleManagementComponent,
				data: { stateName: 'rolemanage'},
				resolve: { apps: ResolverAppsService, userSubs: ResolverUserSubsService }
			},
			// A3I Setting
			{
				path: 'a3i-setting',
				component: A3iSettingComponent,
				canActivate: [SubGuard],
				resolve: { userSubs: ResolverUserSubsService },
				data: {stateName: 'a3isetting', appName: AppSettings.a3iAppName, featureName: 'A3IAdmin'},
				children: [{
					path: 'nag',
					data: { stateName: 'a3inag' },
					component: A3iNagComponent
				}, {
					path: 'api-key',
					component: A3iApikeyComponent				
				}]
			},
			// Hpms Setting
			{
				path: 'hpms-setting',
				canActivate: [SubGuard],
				component: HpmsSettingComponent,
				data: {stateName: 'hpmssetting', appName: AppSettings.hpmsAppName, featureName: 'HPMSAdmin'}
			},
			// LBE Setting
			{
				path: 'lbe-setting',
				component: LbeSettingComponent,
				canActivate: [SubGuard],
				data: { stateName: 'lbesetting', appName: AppSettings.lbeAppName, featureName: 'LBEAdmin' },
				resolve: {
					lbeCustomerAppinfo: ResolverCustomerAppInfoService
				},
				children: [
					// {
					// 	path: '',
					// 	redirectTo: 'upload',
					// 	pathMatch: 'full'
					// },
					{
						path: 'upload',
						data: { stateName: 'lbepuload' },
						component: LbeUploadComponent,
						children: [
							{
								path: '',
								redirectTo: 'arnold',
								pathMatch: 'full'
							},
							{
								path: 'arnold',
								component: LbeUploadArnoldComponent,
								data: { stateName: 'lbeuploadarnold' }
							},
							{
								path: 'events',
								component: LbeUploadEventComponent,
								data: { stateName: 'lbeuploadevent' }
							}
						]
					},
					{
						path: 'lrs',
						component: LbeLrsComponent,
						data: { stateName: 'lbelrs'},
						resolve: { lrsData: ResolverLbeLrsService}
					},
					{
						path: 'map',
						component: LbeMapComponent,
						data: { stateName: 'lbemap'}
						// resolve: { customerInfoResolve: ResolverCustomerAppInfoService}
					},
					{
						path: 'symbology',
						component: LbeSymbologyComponent,
						data: { stateName: 'lbesymbology' },
						resolve: { symbologys: ResolverSymbologysService, projects: ResolverLbeProjectsService }
					},
					{
						path: 'layer-columns',
						component: LbeLayerColumnsComponent,
						resolve: { projects: ResolverLbeProjectsService }
					},
					{
						path: 'photolog',
						component: LbePhotologComponent,
						data: { stateName: 'lbephotolog' }
					}
				]
			},
			// Ninja Setting
			{
				path: 'ninja-settings',
				component: SettingsNinjaComponent,
				canActivate: [SubGuard],
				data: {appName: AppSettings.ninjaAppName, featureName: 'NinjaAdmin'},
				resolve: {
					ninjaInfo: ResolverNinjaInfoService
				},
				children: [
					{
						path: 'layers',
						component: NinjaLayersComponent
					}, {
						path: 'meta',
						component: NinjaMetaComponent
					}
				]
			},
			// Super user
			{
				path: 'super-admin',
				canActivate: [SuperUserGuard],
				data: { stateName: 'superuser' },
				children: [{
					path: '',
					redirectTo: 'organization-manage',
					pathMatch: 'full'
				}, {
					path: 'organization-manage',
					component: OrganizationComponent
				}, {
					path: 'feature-toggle',
					component: FeatureToggleSettingComponent,
					resolve: { apps: ResolverAppsService }
				}, {
					path: 'lbm-config',
					component: LbmConfigComponent
				}, {
					path: 'gistic-site-admin',
					component: GisticSiteAdminComponent,
					resolve: {
						gisticUsers: ResolverGisticUsersService
					}
				}]
			}
		]
	},
	// Authentication
	{
		path: 'auth',
		data: { stateName: 'auth'},
		children: [
			{
				path: 'login',
				component: LoginComponent,
				canActivate: [AuthTypeGuard],
				data: { stateName: 'login'}
			},
			{
				path: 'register',
				component: RegisterComponent,
				resolve: {apps: ResolverAppsService },
				data: { stateName: 'register'}
			},
			{
				path: 'register-message',
				component: RegisterMessageComponent,
				data: { stateName: 'registermessage'}
				// Optional parameter: message
			},
			{
				path: 'register-verify',
				component: RegisterVerifyComponent,
				data: { stateName: 'registerverify'}
			},
			{
				path: 'register-approve',
				component: RegisterApproveComponent,
				// resolve: {infoResolve: ResolverAppinfoService},
				data: { stateName: 'registerapprove' }
			},
			{
				path: 'retrieve-pw',
				data: { stateName: 'retrievepw' },
				component: RetrievePwComponent
			},
			{
				path: 'reset-pw',
				data: { stateName: 'resetpw' },
				component: ResetPwComponent
			},
			{
				path: 'set-pw',
				data: { stateName: 'setpw' },
				component: ResetPwComponent
			},
			{
				path: '',
				redirectTo: 'login',
				pathMatch: 'full'
			},
			{
				path: '**',
				redirectTo: 'login'
			}
		]
	}, */
	// Authentication
	{
		path: 'auth-direct',
		component: AuthDirectComponent
	},
	// Main state
	{ path: '**', redirectTo: 'auth-direct'}
];

@NgModule({
	imports: [
		RouterModule.forRoot(
			appRoutes,
			// { enableTracing: true } // Debugging purposes only !!
		)
	],
	declarations: [],
	exports: [
		RouterModule
	]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts